"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _phoneValidation = require("../utils/phoneValidation");

var _replaceStringWithXs = require("../utils/replaceStringWithXs");

var _splitStringByIndex4 = require("../utils/splitStringByIndex");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function formatEmail(email) {
  if (typeof email !== 'string' || !email || !/@/.test(email)) return '';
  var arr = email.split('@'); // If the email is something like em@example.com return XX@example.com

  if (arr[0].length < 3) return (0, _replaceStringWithXs.replaceWithX)(arr[0]) + '@' + arr[1];

  var _splitStringByIndex = (0, _splitStringByIndex4.splitStringByIndex)(arr[0], arr[0].length - 2),
      before = _splitStringByIndex.before,
      after = _splitStringByIndex.after;

  return (0, _replaceStringWithXs.replaceWithX)(before) + after + '@' + arr[1];
}

function formatPhone(phone) {
  var _getPhoneDigitsOnly;

  if (typeof phone !== 'string' || !phone) return '';
  var copy = (_getPhoneDigitsOnly = (0, _phoneValidation.getPhoneDigitsOnly)(phone)) !== null && _getPhoneDigitsOnly !== void 0 ? _getPhoneDigitsOnly : '';
  var breakPoint = copy.length - 4;

  var _splitStringByIndex2 = (0, _splitStringByIndex4.splitStringByIndex)(copy, breakPoint),
      before = _splitStringByIndex2.before,
      after = _splitStringByIndex2.after;

  var newStrStart = (0, _replaceStringWithXs.replaceWithX)(before);
  var newStrEnd = after;
  return newStrStart + newStrEnd;
}

function formatGenericStr(args) {
  var genericStr = args.genericStr,
      breakPoint = args.breakPoint;

  var _splitStringByIndex3 = (0, _splitStringByIndex4.splitStringByIndex)(genericStr, breakPoint),
      before = _splitStringByIndex3.before,
      after = _splitStringByIndex3.after;

  return (0, _replaceStringWithXs.replaceWithX)(before) + after;
}

function formatData(action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'email':
      return formatEmail(payload);

    case 'phone':
      return formatPhone(payload);

    case 'genericStr':
      return formatGenericStr(payload);

    default:
      return '';
  }
}

var PrivacyDataDisplay = function PrivacyDataDisplay(props) {
  var _props$email = props.email,
      email = _props$email === void 0 ? '' : _props$email,
      _props$phone = props.phone,
      phone = _props$phone === void 0 ? '' : _props$phone,
      genericStr = props.genericStr,
      breakPoint = props.breakPoint;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      display = _useState2[0],
      setDisplay = _useState2[1];

  (0, _react.useEffect)(function () {
    var displayVal = '';

    if (email) {
      displayVal = formatData({
        type: 'email',
        payload: email
      });
    } else if (phone) {
      displayVal = formatData({
        type: 'phone',
        payload: phone
      });
    } else if (genericStr && breakPoint) {
      displayVal = formatData({
        type: 'genericStr',
        payload: {
          genericStr: genericStr,
          breakPoint: breakPoint
        }
      });
    }

    setDisplay(displayVal);
  });
  return /*#__PURE__*/_react.default.createElement("span", null, display);
};

var _default = PrivacyDataDisplay;
exports.default = _default;